import React, { useEffect, useState, useRef, Component, props } from "react";
import firebase from 'firebase/compat/app';
import { toast } from "react-toastify";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import Fotter from '../../Home/Home_modules/Footerr/footer'
import './nftdetail.css'

require('dotenv').config()

var CryptoJS = require("crypto-js");

// function to check payment status

export default class paymentstatus extends Component {
 constructor(props) {
    super(props);
    this.state = {
        orderdata: [],
    };
}


 componentDidMount() {
    const popupState = true;
    loadingPopup(popupState);
    function loadingPopup (value){
        if( value == true){
            document.querySelector('.spinner-over').classList.remove('completed')
            document.querySelector('.spinner-over').classList.add('half-spinner')
            document.querySelector('.spinner').classList.add('spinner-active')
        } else if (value == false){
            document.querySelector('.spinner-over').classList.remove('half-spinner')
            document.querySelector('.spinner-over').classList.add('completed')
            setTimeout(() => {
                document.querySelector('.spinner').classList.remove('spinner-active')
                }, 5000);
        }
    }
    
     const orderid = this.props.match.params.order_id;
     const nftid = this.props.match.params.nftid;
     const cashfreekey = process.env.REACT_APP_CASHFREE_KEY;
     const cashfreesecret = process.env.REACT_APP_CASHFREE_SECRET;
     // status api
        fetch('https://cors-digi.herokuapp.com/https://test.cashfree.com/api/v2/orders/'+orderid+'/status', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-api-version': '2022-01-01',
                'x-client-id': cashfreekey,
                'x-client-secret': cashfreesecret
            }
        })
        .then(response => response.json())
        .then(response => {
            console.log(response);
            if (response.txStatus === 'SUCCESS') {
                toast.success("Payment Successful", {
                    position: toast.POSITION.TOP_CENTER
                    });
                // redirect to confirmation
                const encrypted_file_id = CryptoJS.AES.encrypt(nftid, ''+process.env.REACT_APP_SECRET_KEY).toString().replace('+','xMl3Jk').replace('/','Por21Ld').replace('=','Ml32');
                this.props.history.push('/confirmation/'+nftid+'/'+encrypted_file_id);
                const popupState = false;
                loadingPopup(popupState);
            } else if (response.txStatus === 'FAILED') {
                toast.error("Payment Failed, Redirecting...", {
                    position: toast.POSITION.TOP_CENTER
                    });
                // redirect to nft detail
                this.props.history.push('/nftdetail/'+nftid);
                const popupState = false;
                loadingPopup(popupState);
            }
            else if (response.txStatus === 'PENDING') {
                toast.error("Payment Failed, Redirecting...", {
                    position: toast.POSITION.TOP_CENTER
                    });
                // redirect to nft detail
                this.props.history.push('/nftdetail/'+nftid);
                const popupState = false;
                loadingPopup(popupState);
            }
            else if (!response.txStatus) {
                toast.error("Payment Failed, Redirecting...", {
                    position: toast.POSITION.TOP_CENTER
                    });
                // redirect to nft detail
                this.props.history.push('/nftdetail/'+nftid);
                const popupState = false;
                loadingPopup(popupState);
            }
        })
 }






render() {
    return (
        <div>
            <div className="spinner">
            <span>Checking payment status, Please do not refresh or navigate away</span>
            <div className="spinner-over half-spinner"></div>
        </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="payment-status">
                            <div className="payment-status-header">
                                <h3>Payment Status</h3>
                            </div>
                            <div className="payment-status-body">
                                <div className="payment-status-body-header">
                                    <h4>Checking status</h4>
                                </div>
                                <div className="payment-status-body-content">
                                    <p>Please wait, we are checking the status of your payment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )

}
   

}